import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Col,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  notification,
  Radio,
  Row,
  Select,
  Space,
  Tabs,
} from 'antd'
import React, {
  forwardRef,
  ReactElement,
  useEffect,
  useMemo,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import styles from './recipeQueryList.module.css'
import { Columns, DBColumns, DEColumns } from './columns'
import { DownOutlined, SearchOutlined } from '@ant-design/icons'
import { getDepartmentList } from '../../department/departmentSlice'
import { getDoctorsInDepartmentAsync, getPatientRegistrationAsync, pageRecipeQueryAsync } from './recipeQuery'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../../compnents/form/DateSelect'
import {
  EditableRecipeCategories,
  getRecipeCategoryName,
  getRecipeStatusName,
  RecipeStatus,
} from '../../../models/recipe'
import {
  selectDoctors,
  setDoctors,
  getDoctorsInDepartment,
  getOutpatientDepartment,
  selectDepartments,
} from '../../registration/register/registerSlice'
import {
  selectCredentials,
  selectStationCategory,
  selectUserDepartmentId,
  selectUserId
} from '../../../app/applicationSlice'
import { traceRoute } from '../../../layouts/layoutSlice'
import { set } from 'lodash'
import { TabPane } from '../../../compnents/widgets/TabBar'
import moment from 'moment'
import { DateTimeFormatSimpleOnlyOne } from '../../../models/datetime'
import { PaymentResult } from '../../payment/result/PaymentResult'
import { getSFDoctorListAsync } from '../../sales/DoctorAccont/doctorAuditSlice'
import { TcmRecipeSummary } from './TcmRecipeSummary'
export const RecipeQueryTabWrapper = (props: { tabKey: string }): ReactElement => {
  const [activeTab, setActiveTab] = useState('1')
  return (
    <Col className={styles.main}>
      <Tabs
        activeKey={activeTab}
        onChange={(v) => setActiveTab(v)}
        style={{ height: '100%' }}
      >
        <Tabs.TabPane key="1" tab="处方查询">
          <RecipeQueryContent tabKey={props.tabKey} activeKey={activeTab}/>
        </Tabs.TabPane>
        <Tabs.TabPane key="2" tab="中医处方汇总" >
          <TcmRecipeSummary activeKey={activeTab}/>
        </Tabs.TabPane>
      </Tabs>
    </Col>
  )
}

const RecipeQueryContent = (props: { tabKey: string ,activeKey?: any}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const [form] = Form.useForm()

  const [agentForm] = Form.useForm()

  const [bigForm] = Form.useForm()

  const [editForm] = Form.useForm()

  const [setForm] = Form.useForm()

  const [pageLoading, setPageLoading] = useState(false)

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const [visible, setVisible] = useState(false)

  const [paymentVisible, setPaymentVisible] = useState(false)

  const stationCategory: any = useSelector(selectStationCategory)

  const userId = useSelector(selectUserId)

  const departmentId = useSelector(selectUserDepartmentId)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_chufangchaxun') || '{}'
  ) //数据回显

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
    timeHead: storageParams?.timeHead || timeHead,
    timeTail: storageParams?.timeTail || timeTail,
    [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [agentParams, setAgentParams] = useState<any>({
    current: 1,
    size: 10,
    type: 2,
    patientName: '',
    agentName: '',
    auditorName: '',
    startTime: moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
    endTime: moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
    [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
  })

  const [bigParams, setBigParams] = useState<any>({
    current: 1,
    size: 10,
    type: 1,
    patientName: '',
    auditorName: '',
    agentName: '',
    startTime: moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
    endTime: moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
    [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
  })

  const [data, setData] = useState<any>()

  const [bigData, setBigData] = useState<any>()

  const [active, setActive] = useState('0')

  const departments = useSelector(selectDepartments)

  const doctors = useSelector(selectDoctors)

  const [agentDoctors, setAgentDoctors] = useState<any>([])

  const [paymentId, setPaymentId] = useState<any>()

    const getPage = () => {
    setPageLoading(true)
    dispatch(
      pageRecipeQueryAsync({
        ...params,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const data = {
          total: res.total,
          items: res.records,
        }
        setPage(data)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if(props?.activeKey == '1'){
      if (!params.current) return
      if(stationCategory == 1 ){
        params?.departmentId && getPage()
        return
      }
      getPage()
      sessionStorage.setItem(
          location.pathname + '_chufangchaxun',
          JSON.stringify({ ...params })
      )
    }
  }, [params, props?.activeKey])

  useEffect(() => {
    if(props?.activeKey == 1) {
      // 获取科室
      dispatch(getOutpatientDepartment())
      // 审核药师
      dispatch(getSFDoctorListAsync())
          .then(unwrapResult)
          .then((v: any) => {
            setAgentDoctors(v)
          })
    }
  }, [props?.activeKey])

  useEffect(() => {
    console.log('storageParams',Object.keys(storageParams).length)
    if (
      Object.keys(storageParams).length &&
      location.pathname == '/doctor/station'
    ) {
      form.setFieldsValue({
        param: storageParams?.param || '',
        departmentId: storageParams?.departmentId,
        doctorId: storageParams?.doctorId,
        category: storageParams?.category,
        timeHead: storageParams?.timeHead || timeHead,
        timeTail: storageParams?.timeTail || timeTail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        timeHead: timeHead,
        timeTail: timeTail,
      })
    }
    form.submit()
  }, [])

  useEffect(() => {
    // 医生
    if (stationCategory == 1) {
      if (departmentId) {
        form.setFieldsValue({
          departmentId: departmentId,
        })
        // 通过科室id获取医生列表
        dispatch(getDoctorsInDepartment(`${departmentId}`))
        console.log(userId,doctors,"doctorId")
          form.setFieldsValue({
            doctorId: userId,
          })
      }
    }
  }, [stationCategory]);


  useEffect(() => {
    if (visible) {
      if(active == '0') {
        dispatch(getPatientRegistrationAsync({ ...agentParams }))
        .then(unwrapResult)
        .then((res: any) => {
          setData({
            total: res.total,
            records: res.records,
          })
        })
      } else if(active == '1') {
        dispatch(getPatientRegistrationAsync({ ...bigParams }))
        .then(unwrapResult)
        .then((res: any) => {
          setBigData({
            total: res.total,
            records: res.records,
          })
        })
      }
    }
    return () => {
      if (visible) {
        setData({})
      }
    }
  }, [visible, bigParams, active, agentParams])

  return (
    <Col className={styles.main}>
      <Form
        form={form}
        onFinish={(values) => {
          if (!values?.timeHead && values?._dateRange == 6) {
            return
          } 
          setParams({
            ...storageParams,
            ...params,
            ...values,
            timeHead: values?.timeHead
              ? values?.timeHead
              : storageParams?.timeHead || timeHead,
            timeTail: values?.timeTail
              ? values?.timeTail
              : storageParams?.timeHead || timeTail,
            current: 1,
          })
        }}
      >
        <Row
          style={{ marginTop: 10, marginBottom: 20 }}
          justify="space-between"
        >
          <Space>
            <Form.Item noStyle name="param">
              <Input
                autoComplete="off"
                prefix={<SearchOutlined />}
                maxLength={20}
                placeholder="请输入患者姓名/手机号"
                style={{ width: "13rem" }}
                allowClear
                onChange={form.submit}
              />
            </Form.Item>
            <Form.Item noStyle name="recipeId">
              <Input
                autoComplete="off"
                prefix={<SearchOutlined />}
                placeholder="请输入处方编号"
                style={{ width: "10rem" }}
                allowClear
                onChange={form.submit}
              />
            </Form.Item>
            <Form.Item noStyle name="departmentId">
              <Select
                style={{ width: "7rem" }}
                placeholder="主管科室"
                allowClear
                disabled={stationCategory == 1}
                onChange={(id: string) => {
                  form.setFieldsValue({
                    doctorId: undefined,
                  })
                  if (id) {
                    dispatch(getDoctorsInDepartment(id))
                  } else {
                    dispatch(setDoctors([]))
                  }
                  form.submit()
                }}
              >
                {departments.map((d) => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item noStyle name="doctorId">
              <Select
                style={{ width: "7rem" }}
                placeholder="主管医生"
                allowClear
                disabled={stationCategory == 1}
                onChange={form.submit}
                filterOption={(input, option) => {
                  return option?.className
                    ? ((option?.className as unknown) as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    : false
                }}
              >
                {doctors.map((d) => (
                  <Select.Option
                    className={d.mnemonicCode}
                    key={d.id}
                    value={d.id}
                  >
                    {d.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <Form.Item noStyle name="category">
              <Select
                style={{ width: "7rem" }}
                placeholder="处方类型"
                allowClear
                onChange={form.submit}
              >
                {EditableRecipeCategories?.map((v) => {
                  return (
                    <Select.Option value={v} key={v}>
                      {getRecipeCategoryName(v)}
                    </Select.Option>
                  )
                })}
              </Select>
            </Form.Item>
            <Form.Item noStyle name="state">
              <Select
                style={{ width: "7rem" }}
                placeholder="处方状态"
                allowClear
                onChange={form.submit}
              >
                {[
                  RecipeStatus.ToSettle,
                  RecipeStatus.Settled,
                  RecipeStatus.Returned,
                ].map((s) => (
                  <Select.Option key={s} value={s}>
                    {getRecipeStatusName(s)}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
            <DateSelect
              style={{ width: "7rem" }}
              labelPrefix=""
              allowClear={false}
              namePrefix="time"
              options={TJFXTime}
              placeholder="日期范围-全部"
              initialValue={DateRangeType.Today}
              onChange={() => form.submit()}
            />
            <Button type="primary" htmlType="submit" loading={pageLoading}>
              查询
            </Button>
          </Space>
          <Space>
            <Button
              type="primary"
              style={{ backgroundColor: "#07C160", borderColor: "#07C160" }}
              onClick={() => setVisible(true)}
            >
              处方登记查询
            </Button>
          </Space>
        </Row>
      </Form>
      <EditableList
        loading={pageLoading}
        page={{
          current: params.current,
          size: params.size,
          total: page.total,
          items: page.items,
        }}
        columns={Columns(params.size * (params.current - 1), (action, t) => {
          switch (action) {
            case "action":
              dispatch(
                traceRoute({
                  name: "医生门诊",
                  path: "/treatment",
                  query: `registrationId=${
                    t.registrationId
                  }&cfcxFlag=${true}&station=${props?.tabKey}`,
                  state: {
                    backSelectTab: "editor",
                  },
                })
              )
              break
            default:
              break
          }
        })}
        onChangePage={(current, size) =>
          setParams({
            ...params,
            current,
            size: size || 10,
          })
        }
        // onRow={(d) => ({
        //   onClick: (e) => {
        //     e.stopPropagation()
        //     const isCheck = selectIds.includes(d?.id)
        //     let ids = []
        //     if (isCheck) {
        //       ids = selectIds.filter((id: any) => id !== d?.id)
        //     } else {
        //       ids = [...selectIds, d?.id]
        //     }
        //     setSelectIds(ids as string[])
        //   },
        // })}
      />

      <Modal
        title="处方信息登记"
        visible={visible}
        onCancel={() => {
          setVisible(false)
        }}
        className={styles.ModalBox}
        width={1300}
        footer={null}
      >
        <div className={styles.accountList}>
          <Tabs
            defaultActiveKey="0"
            onChange={(v) => {
              setActive(v)
            }}
          >
            <TabPane tab="代办登记" key={"0"}>
              <Form
                form={agentForm}
                onFinish={(values) => {
                  if (!values?.timeHead && values?._dateRange == 6) {
                    return
                  }
                  setAgentParams({
                    ...agentParams,
                    patientName: values?.patientName || "",
                    auditorName: values?.auditorName || "",
                    agentName: values?.agentName || "",
                    startTime: values?.timeHead
                      ? moment(values?.timeHead).format(
                          DateTimeFormatSimpleOnlyOne
                        )
                      : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
                    endTime: values?.timeTail
                      ? moment(values?.timeTail).format(
                          DateTimeFormatSimpleOnlyOne
                        )
                      : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
                    timeHead: undefined,
                    timeTail: undefined,
                    current: 1,
                  })
                }}
              >
                <Row
                  style={{ marginTop: 10, marginBottom: 20 }}
                  justify="space-between"
                >
                  <Space>
                    <Form.Item noStyle name="patientName">
                      <Input
                        autoComplete="off"
                        prefix={<SearchOutlined />}
                        placeholder="请输入患者姓名"
                        style={{ width: "15rem" }}
                        allowClear
                        onChange={agentForm.submit}
                      />
                    </Form.Item>
                    <Form.Item noStyle name="agentName">
                      <Input
                        autoComplete="off"
                        prefix={<SearchOutlined />}
                        placeholder="请输入代办人姓名"
                        style={{ width: "15rem" }}
                        allowClear
                        onChange={agentForm.submit}
                      />
                    </Form.Item>
                    <Form.Item noStyle name="auditorName">
                      <Select
                        placeholder="审核药师"
                        showSearch
                        allowClear
                        style={{ width: "8rem" }}
                        filterOption={(input, option) => {
                          return option?.className
                            ? ((option?.className as unknown) as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            : false
                        }}
                        onChange={agentForm.submit}
                      >
                        {agentDoctors.map((d: any) => (
                          <Select.Option
                            className={d.mnemonicCode}
                            key={d.id}
                            value={d.realname}
                          >
                            {d.realname}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <DateSelect
                      style={{ width: "7rem" }}
                      labelPrefix=""
                      allowClear={false}
                      namePrefix="time"
                      options={TJFXTime}
                      placeholder="购药时间-全部"
                      initialValue={DateRangeType.Today}
                      onChange={() => agentForm.submit()}
                    />
                    <Button type="primary" htmlType="submit">
                      查询
                    </Button>
                  </Space>
                </Row>
              </Form>
              <EditableList
                page={{
                  size: agentParams.size || 10,
                  current: agentParams.current || 1,
                  total: data?.total || 0,
                  items: data?.records || [],
                }}
                columns={DBColumns(
                  (agentParams.size || 10) * ((agentParams.current || 1) - 1),
                  (text, t) => {
                    if (text === "action") {
                      setPaymentId(t?.paymentId)
                      setPaymentVisible(true)
                    }
                  }
                )}
                onChangePage={(current, size) => {
                  setAgentParams({
                    ...agentParams,
                    current,
                    size: size as number,
                  })
                }}
                onRow={(d: any) => ({
                  onDoubleClick: () => {
                    // onRecord(d)
                  },
                })}
              />
            </TabPane>
            <TabPane tab="大额登记" key={"1"}>
              <Form
                form={bigForm}
                onFinish={(values) => {
                  if (!values?.timeHead && values?._dateRange == 6) {
                    return
                  }
                  setBigParams({
                    ...bigParams,
                    patientName: values?.patientName || "",
                    agentName: values?.agentName || "",
                    auditorName: values?.auditorName || "",
                    startTime: values?.timeHead
                      ? moment(values?.timeHead).format(
                          DateTimeFormatSimpleOnlyOne
                        )
                      : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
                    endTime: values?.timeTail
                      ? moment(values?.timeTail).format(
                          DateTimeFormatSimpleOnlyOne
                        )
                      : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
                    timeHead: undefined,
                    timeTail: undefined,
                    current: 1,
                  })
                }}
              >
                <Row
                  style={{ marginTop: 10, marginBottom: 20 }}
                  justify="space-between"
                >
                  <Space>
                    <Form.Item noStyle name="patientName">
                      <Input
                        autoComplete="off"
                        prefix={<SearchOutlined />}
                        placeholder="请输入患者姓名"
                        style={{ width: "15rem" }}
                        allowClear
                        onChange={bigForm.submit}
                      />
                    </Form.Item>
                    <Form.Item noStyle name="auditorName">
                      <Select
                        placeholder="审核药师"
                        showSearch
                        allowClear
                        style={{ width: "8rem" }}
                        filterOption={(input, option) => {
                          return option?.className
                            ? ((option?.className as unknown) as string)
                                .toLowerCase()
                                .includes(input.toLowerCase())
                            : false
                        }}
                        onChange={bigForm.submit}
                      >
                        {agentDoctors.map((d: any) => (
                          <Select.Option
                            className={d.mnemonicCode}
                            key={d.id}
                            value={d.realname}
                          >
                            {d.realname}
                          </Select.Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <DateSelect
                      style={{ width: "7rem" }}
                      labelPrefix=""
                      allowClear={false}
                      namePrefix="time"
                      options={TJFXTime}
                      placeholder="购药时间-全部"
                      initialValue={DateRangeType.Today}
                      onChange={() => bigForm.submit()}
                    />
                    <Button type="primary" htmlType="submit">
                      查询
                    </Button>
                  </Space>
                </Row>
              </Form>
              <EditableList
                page={{
                  size: bigParams.size || 10,
                  current: bigParams.current || 1,
                  total: bigData?.total || 0,
                  items: bigData?.records || [],
                }}
                columns={DEColumns(
                  (bigParams.size || 10) * ((bigParams.current || 1) - 1),
                  (text, t) => {
                    if (text === "action") {
                      setPaymentId(t?.paymentId)
                      setPaymentVisible(true)
                    }
                  }
                )}
                onChangePage={(current, size) => {
                  setBigParams({
                    ...bigParams,
                    current,
                    size: size as number,
                  })
                }}
              />
            </TabPane>
          </Tabs>
        </div>
      </Modal>

      <Modal
        title="查看"
        visible={paymentVisible}
        onCancel={() => {
          setPaymentVisible(false)
        }}
        className={styles.ModalBox}
        width={1200}
        footer={null}
      >
        <PaymentResult currentPaymentId={paymentId} />
      </Modal>

    </Col>
  )
}

// export const RecipeQueryListS = forwardRef(RecipeQueryList);
